import Cookies from 'js-cookie/src/js.cookie'
import $ from 'jquery'

// if cookie even exists
if ($('.alertBar').length) {
    if (Cookies.get('alertCookie')) {
        // dont show the alert
        $('.alertBar').removeClass('-active').removeClass('-open')
    } else {
        // do show the alert
        $('.alertBar').addClass('-active').addClass('-open')

        // close the alert and set the cookie to prevent the alert from showing again for 3 days
        $('.alertBar__close').on('click', function () {
            $('.alertBar').removeClass('-active').removeClass('-open')
            Cookies.set('alertCookie', true, { expires: 3 })
        })
    }
}
